export default __webpack_public_path__ + "static/media/flowChart.108b13f3.jpg";